"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[477,633],{

/***/ 67244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var AssetsProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 28054));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28054)];
    }
  }
});
var DrawersProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 43928));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43928)];
    }
  }
});
var ThemeProvider = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-providers-layout */[__webpack_require__.e(122), __webpack_require__.e(895), __webpack_require__.e(790), __webpack_require__.e(294)]).then(__webpack_require__.bind(__webpack_require__, 59159));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59159)];
    }
  }
});
var BaseStructure = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() | module-components-baseStructure */[__webpack_require__.e(662), __webpack_require__.e(714), __webpack_require__.e(122), __webpack_require__.e(609), __webpack_require__.e(557), __webpack_require__.e(895), __webpack_require__.e(186), __webpack_require__.e(790), __webpack_require__.e(272), __webpack_require__.e(959), __webpack_require__.e(849), __webpack_require__.e(427)]).then(__webpack_require__.bind(__webpack_require__, 22333));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22333)];
    }
  }
});

var LayoutProvider = function LayoutProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ThemeProvider, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AssetsProvider, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(DrawersProvider, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BaseStructure, {
          children: children
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LayoutProvider);

/***/ }),

/***/ 91196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PianoInitContext": function() { return /* binding */ PianoInitContext; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _react_keycloak_ssr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85069);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57083);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_ecryption__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23119);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var PianoInitContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createContext({});

var PianoInitProvider = function PianoInitProvider(props) {
  var _serverSideContext$si, _serverSideContext$si2;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_4__.useState(),
      _React$useState2 = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      tinypass = _React$useState2[0],
      setTinypass = _React$useState2[1];

  var _useKeycloak = (0,_react_keycloak_ssr__WEBPACK_IMPORTED_MODULE_1__.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var pianoUrl = "https://experience.tinypass.com/xbuilder/experience/load?aid=WNAhBduApu";
  var serverSideContext = react__WEBPACK_IMPORTED_MODULE_4__.useContext(providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_3__.ServerSidePropsContext);
  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error("Error during login:", _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function () {
    var tp = window.tp || [];
    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push(["setPageURL", window.location.href]);

    if (isPaywall === "PIANO") {
      if ((tp === null || tp === void 0 ? void 0 : tp.aid) === undefined || tp === undefined) {
        (function (src) {
          var _b$parentNode;

          var a = document.createElement("script");
          a.type = "text/javascript";
          a.async = true;
          a.id = "pianoJs";
          a.src = src ? src : "";
          var b = document.getElementsByTagName("script")[0];
          (_b$parentNode = b.parentNode) === null || _b$parentNode === void 0 ? void 0 : _b$parentNode.insertBefore(a, b);
        })(pianoUrl);
      }

      setTinypass(tp);
    } else {
      var b = document.getElementsByTagName("script");

      for (var i = 0; i < b.length; i++) {
        if (b[i].innerHTML.indexOf("tinypass") !== -1) {
          b[i].remove();
        }
      }
    }
  }, [router.asPath, keycloak]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var tp = window.tp || [];
    tp.push(["addHandler", "loginRequired", function (params) {
      handleLogin();
    }]);
    tp.push(["init", function () {
      if (keycloak) {
        if (tp.pianoId.isUserValid() == false) {
          var _tp$pianoId;

          (_tp$pianoId = tp.pianoId) === null || _tp$pianoId === void 0 ? void 0 : _tp$pianoId.loginByToken((0,utils_ecryption__WEBPACK_IMPORTED_MODULE_5__/* .decrypt */ .p)(keycloak === null || keycloak === void 0 ? void 0 : keycloak.token)).then(function (res) {
            tp.experience.init();
          });
        }
      } else {
        tp.experience.init();
      }
    }]);
  }, [keycloak]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(PianoInitContext.Provider, {
    value: {
      tp: tinypass
    },
    children: props.children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PianoInitProvider);

/***/ })

}]);